// extracted by mini-css-extract-plugin
module.exports = {"img":"marker_img__3b-cj"};